import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'
import { HelperFunctions } from '../../../_shared/utils/helper-functions'

declare var jQuery: any
@Component({
  selector: 'app-financial-lit-topics',
  templateUrl: './financial-lit-topics.component.html',
  styleUrls: ['./financial-lit-topics.component.scss'],
})
export class FinancialLitTopicsComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private _router: Router,
    private helperFunctions: HelperFunctions
  ) {}

  countryName: string
  model: any
  loading: boolean
  literacyTopicsData: any
  filteredLiteracyTopicsData: any
  isLoadingTopics: boolean
  isAddingTopic: boolean
  topicsCount: number
  message: string
  status: string
  selectedLanguage: string = 'English'
  selectedFile: any = null
  searchItem: string

  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
      ['link', 'image', 'video'],
    ],
  }

  editorStyle = {
    height: '100px',
    marginBottom: '10px',
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
    this.model = {}
    this.loadFinancialLiteracyTopics()
  }

  changeImage(event) {
    this.selectedFile = <File>event.target.files[0]
  }

  loadFinancialLiteracyTopics() {
    this.isAddingTopic
      ? (this.isLoadingTopics = false)
      : (this.isLoadingTopics = true)
    this.requestService
      .dash_get(
        `financial/literacy/topic/${this.countryName}/${this.selectedLanguage}`,
        null
      )
      .subscribe((res) => {
        this.isLoadingTopics = false
        this.literacyTopicsData = res.data
        this.filteredLiteracyTopicsData = res.data
        this.topicsCount = res.data.length
      })
  }

  addLiteracyTopic(addLiteracyTopicForm) {
    this.loading = true
    let formData = new FormData()

    if (this.selectedFile) {
      formData.append('photo', this.selectedFile, this.selectedFile.name)
    }
    formData.append('topic', addLiteracyTopicForm.topic)
    formData.append('description', addLiteracyTopicForm.description)
    formData.append('language', this.selectedLanguage)

    this.requestService
      .dash_putWithImage(
        `financial/literacy/topic/${this.countryName}/${this.selectedLanguage}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          this.isAddingTopic = true
          if (res.success === true) {
            this.message = res.message
            this.loadFinancialLiteracyTopics()
            this.status = 'success'
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetAddModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  getTopicDetails(topic: string, selectedLanguage: string) {
    localStorage.setItem('literacy_topic', topic)
    localStorage.setItem('selected_language', selectedLanguage)
    this._router.navigateByUrl('/financial')
  }

  resetAddModal() {
    jQuery('#addLiteracyTopicModal').modal('hide')
    jQuery('#topicForm')[0].reset()
    this.selectedFile = null
    this.isAddingTopic = false
  }

  filterLiteracyTopics(event) {
    this.searchItem = event.target.value
    this.filteredLiteracyTopicsData = this.literacyTopicsData.filter(
      (input) =>
        input.topic.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addLiteracyTopicModal').on('hidden.bs.modal', () => {
        this.resetAddModal()
      })
    })
  }
}
